// Skyhawk - A Vector Arcade Game Clone
// Entry point

import { Game } from './core/Game';

function init(): void {
  const canvas = document.getElementById('game-canvas') as HTMLCanvasElement;

  if (!canvas) {
    console.error('Could not find game canvas!');
    return;
  }

  const game = new Game(canvas);
  game.start();

  console.log('Skyhawk initialized - good luck pilot!');
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
